<template>
    <span>
        <div v-if="showReplacementPopup" @click.self="showReplacementPopup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
            <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                <div class="rg-modal-header">
                    Modify Response

                    <a href="javascript: void(0);" class="rg-modal-close-btn" @click="showReplacementPopup = false"><i class="mdi mdi-close"></i></a>
                </div>

                <div class="p-6" style="position: relative; overflow: auto;">

                    <div style="clear: both;"></div>

                    <p class="mb-1 text-xs mb-2"><strong>Improve or fix issues in the assistant's answer.</strong></p>

                    <div>
                        <textarea v-model="replacement" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" style="padding-right: 35px !important; height: 250px !important;"
                            :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"></textarea>
                        
                    </div>

                </div>

                <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                    <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" @click="saveReplacement">
                        SAVE
                    </button>

                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showReplacementPopup = false">
                        CLOSE
                    </button>

                <div class="clearfix"></div>

                </div>
            </div>
        </div>
        
        &nbsp;&nbsp;

        <a href="javascript: void(0);" @click="setReinforcementLearning(index, 1)"><i style="font-size: 18px; color: #000000;" :class="((messageStatus == 1) ? 'mdi mdi-thumb-up' : 'mdi mdi-thumb-up-outline')"></i></a>
        
        &nbsp;&nbsp;

        <a href="javascript: void(0);" @click="setReinforcementLearning(index, 2)"><i style="font-size: 18px; color: #000000;" :class="((messageStatus == 2) ? 'mdi mdi-thumb-down' : 'mdi mdi-thumb-down-outline')"></i></a>
    </span>
</template>

<script>
import axios from 'axios'

export default {
    props: [ 'message' ],
    components: {
        
    },
    data() {
        return {
            messageStatus: 0,
            replacement: "",
            showReplacementPopup: false
        }
    },
    methods: {
        async setReinforcementLearning(message, status) {
            this.messageStatus = status;

            if (status == 2) {
                this.showReplacementPopup = true;
                if (!this.replacement)
                    this.replacement = this.message;
            }

            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-reinforcement-learning-status`, {
                status: status,
                message: this.message,
                replacement: this.replacement
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            });
        },

        saveReplacement() {
            this.setReinforcementLearning(this.message, this.messageStatus);

            this.showReplacementPopup = false;
        },

        async pullReinforcementLearning(message, status) {
            this.messageStatus = status;

            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/pull-reinforcement-learning`, {
                message: this.message
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            });

            this.messageStatus = response.data.status;
            this.replacement = response.data.replacement;
        },
    },

    created() {
        this.pullReinforcementLearning();
    }
};
</script>